import React, { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/DeleteForeverRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { RAIL_LABEL } from "../../../constants/configuration.const";
import DragHandleIcon from "@mui/icons-material/DragIndicator";
import LockIcon from "@mui/icons-material/Lock";
import { CW_CAROUSEL } from "../LandingPage/constants";
import { Tooltip } from "@mui/material";

const ContentCurationCard = ({
    dragHandleProps,
    onClickDelete,
    onClickEdit,
    onClickAdd,
    data,
    className,
    hideAddButton,
    allowEdit,
    handleUnlock,
}: any) => {
    // hooks

    const [hideAddButtonState, setHideAddButtonState] = useState(hideAddButton);

    useEffect(() => {
        setHideAddButtonState(hideAddButton);
    }, [hideAddButton]);

    const handleUnlockClick = () => {
        if (data?.template == CW_CAROUSEL && !data?.unlock) {
            handleUnlock();
        }
    };

    return (
        <div
            className={
                "curation-list-card-container d-flex j-center curation-card"
            }
        >
            <div {...dragHandleProps} className="d-flex float-center">
                {className == "curation-card" ? (
                    <DragHandleIcon className="drag-handle" />
                ) : (
                    <LockIcon
                        onClick={handleUnlockClick}
                        className={`drag-handle ${
                            data.template == CW_CAROUSEL && "cursor-pointer"
                        }`}
                    />
                )}
            </div>
            <div className="curation-list-card curation-list-card-highlight">
                {/* Row One */}
                <div {...dragHandleProps} className="d-flex j-space">
                    <span className="curation-title">
                        #{RAIL_LABEL[data.template]}{" "}
                        {data.playlistId && `(Id: ${data.playlistId})`}
                    </span>
                    <div>
                        {allowEdit && (
                            <Tooltip title="Delete">
                                <span
                                    className="cursor-pointer delete-circle-style"
                                    onClick={onClickDelete}
                                >
                                    <DeleteIcon />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                </div>

                {/* row content */}
                <div {...dragHandleProps}>{data.railTitle}</div>

                {/* row bottom */}
                <span
                    onClick={onClickEdit}
                    className={`${
                        allowEdit
                            ? "curation-edit cursor-pointer"
                            : "disabled-span"
                    }`}
                >
                    Edit Rail
                </span>
            </div>
            <div className="curation-list-card-container-span">
                {!hideAddButtonState && allowEdit && (
                    <Tooltip title="Add New Rail">
                        <span
                            className="cursor-pointer add-circle-style"
                            onClick={onClickAdd}
                        >
                            <AddCircleOutlineIcon />
                        </span>
                    </Tooltip>
                )}
            </div>
        </div>
    );
};

export default ContentCurationCard;
